// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Users_establishments__1BBoI","header":"Users_header__180kh","tableHeader":"Users_tableHeader__3v6-O"};